import { useDecision } from '@optimizely/react-sdk'

import { Types } from '@tribeplatform/gql-client'
import { useAuthToken } from '@tribeplatform/react-sdk/hooks'

import { FeaturesList } from '../../lib/optimizely/feature.list'

export const useMobileBottomNavigation = () => {
  const { data: authToken } = useAuthToken()
  const isGuest =
    !authToken?.role?.type || authToken?.role?.type === Types.RoleType.guest

  const [decisionMobileBottomNavigation] = useDecision(
    FeaturesList.MobileBottomNavigation,
  )

  const enabled = !isGuest && decisionMobileBottomNavigation.enabled

  return {
    enabled,
  }
}
